module.exports = __webpack_public_path__ + "img/V-45-ER-550-BB.993bbfe1.png";